<template>
  <section v-editable="blok" banner-card :data-spacing="blok?.spacing || 'white'" :data-theme="blok?.theme || 'light'" :data-style="blok?.style || 'default'">
    <div class="container">
      <div class="row">
        <div class="card" :class="{ 'card-has-mobile': blok?.image_mobile?.filename }" :style="[backgroundGradient(blok)]">
          <div class="card-content">
            <h2 v-if="hasRichTextContent(blok?.title)" class="card-title" v-html="title"></h2>
            <div v-if="hasRichTextContent(blok?.description)" class="card-description" v-html="description"></div>
            <div class="card-buttons">
              <StoryblokComponent v-for="button in blok.buttons" :key="button._uid" :blok="button" />
            </div>
          </div>

          <figure v-if="blok?.image?.filename" class="card-image" :class="{ 'card-has-mobile': blok?.image_mobile?.filename }" :data-align="blok?.image_position || 'center'">
            <NuxtImg v-if="blok?.image?.filename" provider="storyblok" :src="blok.image.filename" :alt="`Card Image`" class="card-image-element" loading="lazy" :width="getImageDimensions(blok.image.filename).width" :height="getImageDimensions(blok.image.filename).height" />
            <NuxtImg v-if="blok?.image_mobile?.filename" provider="storyblok" :src="blok.image_mobile.filename" :alt="`Card Image Mobile`" class="card-image-element-mobile" loading="lazy" :width="getImageDimensions(blok.image_mobile.filename).width" :height="getImageDimensions(blok.image_mobile.filename).height" />
          </figure>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
import type { BannerCardStoryblok } from '~/types/storyblok'
import getImageDimensions from '~/utils/getImageDimensions'
import hasRichTextContent from '~/utils/hasRichTextContent'

interface Props {
  blok: BannerCardStoryblok
}

const props = defineProps<Props>()
const title = computed(() => useRichText(props.blok?.title || {}))
const description = computed(() => useRichText(props.blok?.description || {}))

const backgroundGradient = (tab: BannerCardStoryblok) => {
  if (!tab.background_gradient) return null
  return {
    background: tab.background_gradient,
  }
}
</script>
<style src="~/assets/scss/section/banner-card.scss" lang="scss"></style>
